/**
 * Authentication Page Script
 * Handles URL parameter parsing and auth form initialization
 */

// Get URL parameters
const urlParams = new URLSearchParams(window.location.search);
const userType = urlParams.get('type'); // 'parent' or 'teacher'
const mode = urlParams.get('mode'); // 'login' or 'signup'

// Get the auth form component
const authForm = document.getElementById('authForm') as HTMLSciAuthFormElement;

// Set initial mode and user type if provided
if (mode) {
  authForm.initialMode = mode as 'login' | 'signup';
}

if (userType === 'parent' || userType === 'teacher') {
  authForm.userType = userType;
}
